import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { getSelectOptions, updateComponent, fetchData } from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import { camelize } from '../../utils'
import { uniqBy } from 'lodash'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import MobileDetect from 'mobile-detect'
import './styles.css'
import { CONTEXT_ROOT } from '../../utils'

class CountryCode extends Component {
    constructor(props) {
        super(props)
        this.handleClickOutside = this.handleClickOutside.bind(this)
    }

    componentWillMount() {
        if (
            this.props.component.hasOwnProperty('options') &&
            (this.props.component.values || []).length === 0 &&
            !this.props.component.fetchInProgress
        ) {
            const { dispatch } = this.props
            this.props.component.fetchInProgress = true
            dispatch(getSelectOptions(this.props.component))
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
        const { dispatch } = this.props
        dispatch(fetchData(this.props.component.id, null, true))
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside(event) {
        if (this.node.contains(event.target)) { return }
        const { dispatch, component } = this.props
        dispatch(updateComponent(component.id, { listOpen: false }))
    }

    componentWillReceiveProps(nextProps) {
        const { dispatch } = this.props
        if (
            (nextProps.component &&
                this.props.component.values.length === 0 &&
                nextProps.component.values.length >= 0) ||
            (nextProps.component &&
                this.props.component.values.length > 0 &&
                nextProps.component.values.length === 0)
        ) {
            if (!this.props.component.value && !!this.props.component.initialValue) {
                this.props.component.value = this.props.component.initialValue
            }

            if (
                this.props.component.hasOwnProperty('options') &&
                (this.props.component.values || []).length === 0 &&
                !this.props.component.fetchInProgress
            ) {
                this.props.component.fetchInProgress = true
                dispatch(getSelectOptions(this.props.component))
            }
        }
    }

    onValueChange(countryCode) {
        const { dispatch, component } = this.props
        dispatch(updateComponent(component.id, {
            value: countryCode.value,
            label: countryCode.label,
            listOpen: false
        }))
    }

    toggleList = () => {
        const { dispatch, component } = this.props
        dispatch(updateComponent(component.id, { listOpen: !component.listOpen }))
    }

    renderOptions() {
        const { component } = this.props
        let values = component.values
        let isObjectArray = false
        const assetsPath = `${CONTEXT_ROOT}/assets/flags/`
        
        if (values &&
            values.constructor.toString().indexOf('Array') > -1 &&
            typeof values[0] === 'object') {
            values = values.filter(v => !!v.value && v.value !== '-1')
            isObjectArray = true
            values = uniqBy(values, 'value')
        } else {
            values = Array.from(new Set(values))
        }

        return component.values.map((item) => (
            <li className="dd-list-item"
                key={item.value}
                onClick={() => this.onValueChange(item)}>
                 <img src={assetsPath + item.value.substr(1) + '.svg'}
                    {...css(this.props.styles.image)} />
                {/* {' (' + item.value + ')'} */}
                {' ' + item.label}
            </li>
        ))
    }

    render() {
        const { widget, component } = this.props
        const md = new MobileDetect(window.navigator.userAgent)
        const assetsPath = `${CONTEXT_ROOT}/assets/flags/`
        const isResumePage = window.location.pathname.indexOf('/resume') >= 0 ? true : false

        return (
            <div {...css(this.props.styles.component, component.fullWidth && this.props.styles.singleField,
                component.id === 'CELLULARE-PREF_CELLULARE' && !md.mobile() && !isResumePage && this.props.styles.divPrefix,
            this.props.styles.countryCodeComponent )}
                ref={node => { this.node = node }}>

                <div className="dd-header" onClick={this.toggleList}
                    {...css(
                        this.props.styles.input,
                        this.props.styles.flagInput,
                        this.props.styles['input--select'],
                        component.status.indexOf('error') > -1 &&
                        this.props.styles['input--invalid'],
                        component.status.indexOf('loading') > -1 &&
                        this.props.styles['input--blink'],
                        !component.value && this.props.styles['input--unset']
                    )}>
                    <img src={assetsPath + component.value.substr(1) + '.svg'}
                        {...css(this.props.styles.image)} />
                    {/* {' (' + component.value + ')'} */}
                    {!!component.label ? ' ' + component.label : ''}
                </div>
                {component.listOpen && <ul className="dd-list">
                    {this.renderOptions()}
                </ul>}

                <span
                    {...css(this.props.styles.label,
                        component.value !== '' && this.props.styles['label--active'],
                        this.props.isInModal && this.props.styles['label-neutral']
                    )} >
                    {component.cleanName}
                </span>
                <small {...css(this.props.styles['error-msg'])}>
                    {camelize(component.errorMessage[0], true, true)}
                </small>
            </div>
        )
    }
}

CountryCode.propTypes = {
    widget: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    styles: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
    const { step } = state
    return { step }
}

export default connect(mapStateToProps)(withStyles(Styles)(CountryCode))


// WEBPACK FOOTER //
// ./components/countryCode/index.js